import * as Colors from 'material-ui/styles/colors';

export default {
  actionButtonWrapper: {
    position: 'absolute',
    transform: 'translateY(-100%)',
    marginTop: '-4px',
    userSelect: 'none',
    boxSizing: 'border-box',
    height: 'auto',
    transition: 'margin 250ms ease-in-out',
  },
  actionButtonWrapperRichText: {
    marginTop: '-76px'
  },
  actionButton: {
    whiteSpace: 'nowrap'
  }
};
